<template><div><h1 id="zahlungsverbindungen-person" tabindex="-1"><a class="header-anchor" href="#zahlungsverbindungen-person"><span>Zahlungsverbindungen Person</span></a></h1>
<p>Zahlungsverbindungen der Person — Zahlungsverbindungen der Person (für Zusagen)</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Für Zusagen mit Zahlungsmodus wie LSV, BAD, Kreditkarte oder Paynet müssen personenspezifische Daten für die periodische Zahlungsabwicklung abgelegt werden.</p>
<p>Pfad: <code v-pre>Personen → Personen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Typ (Zahlungsmodus)</dt>
<dd>Gilt für Zusagen mit diesem <a class="link" href="ft.refdata.systblzahlmod.html" title="Zahlungsmodi">Zahlungsmodus</a>.</dd>
<dt>Paynet ID</dt>
<dd>PayNet-ID (nur bei Zahlungsmodus PayNet).</dd>
<dt>Kontonummer</dt>
<dd>IBAN des Zusagers (nur bei Zahlungsmodus LSV).</dd>
<dt>Clearing/Bank</dt>
<dd>Bank-Clearingnummer und Name des Finanzinstitutes. Wird automatisch eingetragen nach Erfassung der IBAN.</dd>
<dt>PC-Nummer</dt>
<dd>IBAN des Kundenkontos (nur bei Zahlungsmodus BAD).</dd>
<dt>Kreditkarte</dt>
<dd>Aussteller der Kreditkarte, z.B. Visa oder Mastercard (nur bei Zahlungsmodus KreditKarte).</dd>
<dt>Nummer</dt>
<dd>Nummer der Kreditkarte in abgekürzter Form, z.B. ************0000 (nur bei Zahlungsmodus KreditKarte).</dd>
<dt>Gültig bis (Monat/Jahr)</dt>
<dd>Ablaufdatum der Kreditkarte (nur bei Zahlungsmodus KreditKarte).</dd>
<dt>Name</dt>
<dd>Vorgesehen für Name auf der Kreditkarte, wird aber nicht in jedem Fall übernommen (nur bei Zahlungsmodus KreditKarte).</dd>
<dt>CardRefID</dt>
<dd>Ersatzwert (bei Saferpay) für Kreditkartennummer und Verfalldatum oder Bankverbindung (nur bei Zahlungsmodus KreditKarte).</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionalität</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.systblzahlmod.html" title="Zahlungsmodi">Zahlungsmodus</RouteLink>, <RouteLink to="/manual/customer/zusagen.html" title="11. Zusagenbearbeitung">Zusagenbearbeitung</RouteLink></p>
</div></template>


